import { ExceptionType } from '../constants';
import {
  PostgresValidationErrorModel,
  ValidationExceptionModel,
} from '../models';
import { AxiosError } from 'axios';
import { FormikErrors } from 'formik';

export function transformServerErrorToFormik<T>(
  axiosError: AxiosError<
    ValidationExceptionModel | PostgresValidationErrorModel
  >,
): FormikErrors<T> {
  const data = axiosError?.response?.data;

  if (!data) {
    return null;
  }

  const { column } = data as PostgresValidationErrorModel;
  const { validationErrors } = data as ValidationExceptionModel;

  if (data.type === ExceptionType.Postgres && column) {
    return <FormikErrors<T>>{
      [column]: data.message,
    };
  }

  if (!validationErrors) {
    return null;
  }

  return validationErrors.reduce((acum, error) => {
    if (!error) {
      return acum;
    }

    const curErrors = {
      ...acum,
      [error.path ? error.path.join('.') : 'unknown']: error.message,
    };

    if (acum[error.key]) {
      return curErrors;
    }

    return {
      ...curErrors,
      [error.key]: error.message,
    };
  }, {});
}
